import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { usePopupDialog } from '@/hooks/use_popup_dialog';
import { showError } from '@/hooks/use_purchase_items_error';
import { UseActionExecuteType } from '@/models/action_base';

/**
 * 購入商品のバリデーションを行う
 */
export function useActionPurchaseItemsCheck(): UseActionExecuteType {
  const { purchaseItem } = useInsertDataStore();
  const { purchaseStore } = useInsertDataStore();
  const popupDialog = usePopupDialog();

  return async () => {
    const dialogText: string[] = [];
    showError.value = true;
    if (!purchaseStore.value || !purchaseStore.value.name) {
      dialogText.push('購入店舗が未入力です。');
    }
    if (!purchaseItem.value || !purchaseItem.value.name) {
      dialogText.push('購入商品が未入力です。');
    }

    if (dialogText.length) {
      await popupDialog.alert(dialogText.join('\n'));
      return true;
    }
    showError.value = false;
    return false;
  };
}
